@if (IconProviderMap[provider()]) {
  <div class="tw-size-[70px] tw-content-center">
    <bit-svg [content]="IconProviderMap[provider()]" [ariaLabel]="name()" />
  </div>
}
